import { NgModule } from "@angular/core";
import {Routes, RouterModule, NoPreloading} from "@angular/router";
import { SelectProfileComponent } from "@modules/commom/select-profile/select-profile.component";
import { SelectProfileCanDeactivateGuard, GetPartnerUserInfoCanDeactivateGuard } from "./core/guards/select-profile.guard";
import {LoginComponent} from "@modules/public/login/login.component";
import {WelcomeComponent} from "@modules/public/login/components/welcome/welcome.component";
import {FirstAccessComponent} from "@modules/public/login/components/first-access/first-access.component";
import {NotfoundComponent} from "@shared/components/auxiliary-page/notfound/notfound.component";
import {environment} from "@env";
import {SSOProviderEnum} from "./core/auth/sso-provider.enum";
import {getIdentifierAutomatizedTest, getIdentifierTestQa} from "./core/auth/automated-test-identifier";
import { AuthBridgeSuccessComponent } from "@modules/public/login/components/auth-bridge-success/auth-bridge-success.component";
import {checkProfileGuard} from "./core/guards/check-profile.guard";
import {ProfileType} from "@variables/profileType";
import {RedirectHandlerComponent} from "@modules/public/redirect-handler/redirect-handler.component";

const routes: Routes = [
  { path: "login", component: LoginComponent },
  {
    path: "login/auth-bridge-success",
    component: AuthBridgeSuccessComponent
  },
  {
    path: "login/bem-vindo",
    component: WelcomeComponent,
    data: { ssoIdentifier: SSOProviderEnum.EdenredConnect, isBackofficeRoute: false }
  },
  {
    path: "link/:code",
    component: RedirectHandlerComponent
  },
  {
    path: "login/atendimento",
    component: WelcomeComponent ,
    data: { ssoIdentifier: SSOProviderEnum.RepomIdentity, isBackofficeRoute: true }
  },
  { path: "primeiro-acesso", component: FirstAccessComponent },
  {
    path: 'selecionar-perfil',
    component: SelectProfileComponent,
    canActivate: [checkProfileGuard],
    data: { profileAuthorized: [ProfileType.ALL_PROFILES] },
    canDeactivate: [
      SelectProfileCanDeactivateGuard,
      GetPartnerUserInfoCanDeactivateGuard
    ],
  },
  {
    path: 'selecionar-contrato',
    loadChildren: () =>
      import('@modules/customer/select-contracts/select-contracts.module').then(
        (m) => m.SelectContractsModule
      ),
    canActivate: [checkProfileGuard],
    data: { roles: '', contractRequired: false, profileAuthorized: [ProfileType.CUSTOMER, ProfileType.RELATIONSHIP] },
  },
  { path: '**', component: NotfoundComponent }, // esta linha tem que ficar por ultimo.
];

if (!environment.prod) {
  routes.unshift(
    {
      path: 'login/bem-vindo/teste-automatizado',
      component: WelcomeComponent,
      data: {
        ssoIdentifier: SSOProviderEnum.EdenredConnectTest,
        isBackofficeRoute: false,
        isTestEnv: true,
        inputIdentifyValue: getIdentifierAutomatizedTest()
      }
    },
    {
      path: 'login/bem-vindo/qa-test',
      component: WelcomeComponent,
      data: {
        ssoIdentifier: SSOProviderEnum.EdenredConnectTest,
        isBackofficeRoute: false,
        isTestEnv: true,
        inputIdentifyValue: getIdentifierTestQa()
      }
    }
  );
}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      errorHandler: (error) => {
        console.error('[Routing Error] Falha na navegação do Angular Router:', {
          mensagem: error?.message || 'Erro desconhecido',
          url: error?.url || 'URL não disponível',
          erro: error
        });
      }
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
